module.exports = __webpack_public_path__ + "img/pesquisa-preto.25e03719.png";